import classNames from 'classnames';
import { isUndefined } from 'lodash';
import React from 'react';

import { fmtPrice, fmtPercent } from '@upstart/harmony/lib/formatter';
import { ConsolidatedDownPaymentRate } from '@upstart/harmony/lib/legos/financingTypes';
import { isDefined } from '@upstart/harmony/lib/legos/utils/tsutils';

import Tooltip from '../../components/Tooltip';

import './DownPaymentTooltip.scss';

export function DownPaymentTooltip({
  rates,
  highlightedRateId,
  isOverLimit,
  isUnderLimit,
}: {
  rates: ConsolidatedDownPaymentRate[];
  highlightedRateId?: string;
  isOverLimit?: boolean;
  isUnderLimit?: boolean;
}) {
  const filteredRates = rates.filter(
    rate =>
      !isUndefined(rate.minDownPaymentAmount) &&
      !isUndefined(rate.maxDownPaymentAmount),
  );

  if (filteredRates.length === 0) {
    return null;
  }

  let highlightedRateIndex = rates.findIndex(
    rate => highlightedRateId && rate.rateIds.includes(highlightedRateId),
  );
  if (highlightedRateIndex === -1 && isUnderLimit) {
    highlightedRateIndex = 0;
  }
  if (highlightedRateIndex === -1 && isOverLimit) {
    highlightedRateIndex = rates.length - 1;
  }

  // Window the list to only show 5 down payments at a time
  const minIndex = Math.max(
    0,
    Math.min(highlightedRateIndex - 2, rates.length - 5),
  );
  // If there is no current rate, show all down payment options
  const maxIndex = highlightedRateIndex >= 0 ? minIndex + 5 : rates.length;

  const content = (
    <div className="downPaymentTooltipContent">
      {filteredRates.slice(minIndex, maxIndex).map((rate, i) => (
        <div
          key={rate.rateIds[0]}
          className={classNames(
            'downPaymentTooltipLine',
            highlightedRateIndex === i + minIndex ? 'selected' : '',
            isOverLimit || isUnderLimit || !rate.apr ? 'error' : '',
          )}
        >
          <span>
            {fmtPrice(rate.minDownPaymentAmount!)}-
            {fmtPrice(rate.maxDownPaymentAmount!)}
          </span>
          <span className="downPaymentTooltipAmount">
            {isDefined(rate.apr) ? fmtPercent(rate.apr) : 'No Rate'}
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <Tooltip width={250} text={content}>
      <i className="downPaymentTooltip glyphicon glyphicon-info-sign" />
    </Tooltip>
  );
}
